import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { PaymentService } from "../../../services/payment-service";
import ReactJson from "react-json-view";

export const Paymentedit = (props) => {
  const { paymentID } = useParams();

  useEffect(() => {
    PaymentSearchID();
  }, []);

  const [settinginfo, setSettingInfo] = useState({});

  const PaymentSearchID = async () => {
    try {
      const result = await PaymentService.paymentDetailsID(paymentID);
      setSettingInfo(result);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6> Payment Log View</h6>
            </div>
            <div className="ms-panel ms-panel-fh">
              <div className="ms-panel-body">
                <ReactJson src={settinginfo} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Paymentedit;
